import React, { ReactNode } from 'react';
import { t } from '@lingui/macro';
import ConfirmationPopover from '@mos-cat/confirmation-popover';
import { i18n } from '../../../helpers/i18n';

export interface DeleteMarriageInfoPopoverProps {
  isPopoverOpen: boolean;
  onPopoverClose?(): void;
  onConfirm?(): void;
  onCancel?(): void;
  children?: ReactNode;
  position?: string;
}

function DeleteMarriageInfoPopover({
  children,
  ...restprops
}: DeleteMarriageInfoPopoverProps): JSX.Element {
  return (
    <ConfirmationPopover
      floating
      title={i18n._(t`Изменить сведения о браке`)}
      description={i18n._(t`Все сведения о супруге и браке будут потеряны`)}
      acceptText={i18n._(t`Изменить`)}
      cancelText={i18n._(t`Не изменять`)}
      className="DeleteMarriageInfoPopover"
      {...restprops}
      wrapperClassName="Form__Popover_wrapper"
    >
      {children}
    </ConfirmationPopover>
  );
}

export default DeleteMarriageInfoPopover;
